import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import { Button, ButtonGroup, Stack } from "@mui/material";
import { formatarCodTribNac } from "../../../utils/infoUtils";

const paginationModel = { page: 0, pageSize: 5 };

export default function CatalogListComponent({
  catalogList,
  layout,
  setSelectedValue,
  setBtnUpdateCatalog,
  loadingCatalogList,
  loadCatalog,
  deleteById,
}) {
  let [disableBtn, setDisableBtn] = React.useState(false);

  const columns = [
    { field: "id", headerName: "ID", width: 150, hide: true },
    {
      field: "name",
      headerName: "Nome",
      width: 200,
    },
    ...(["nfse"].includes(layout)
      ? [
          {
            field: "trib_issqn_type",
            headerName: "Tibutação ISS",
            width: 150,
            renderCell: (params) => (
              <div className="rowitem">
                {params.row.nfse?.trib_issqn_type?.name}
              </div>
            ),
          },
          {
            field: "aliquota",
            headerName: "Aliquota ISS",
            width: 140,
            renderCell: (params) => (
              <div className="rowitem">
                {parseFloat(params.row.nfse?.aliq_iss ?? 0).toFixed(2) + "%"}
              </div>
            ),
          },
          {
            field: "cod_trib_nac",
            headerName: "Código Tributário",
            width: 140,
            renderCell: (params) => (
              <div className="rowitem">
                {formatarCodTribNac(params.row.nfse?.cod_trib_nac?.id)}
              </div>
            ),
          },
        ]
      : []),
    {
      field: "price",
      headerName: "Preço",
      width: 140,
      description: "Valor do Serviço.",
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {parseFloat(params.row.price).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
          </div>
        );
      },
    },
    {
      headerName: "Ação",
      width: 140,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            <ButtonGroup variant="contained" aria-label="Basic button group">
              <Button
                size="small"
                onClick={(e) => {
                  setBtnUpdateCatalog(true);
                  setSelectedValue(params.row);
                }}
                disabled={disableBtn}
              >
                Editar
              </Button>
              <Button
                size="small"
                color="error"
                onClick={async (e) => {
                  setDisableBtn(true);
                  await deleteById(params.row.id);
                  setDisableBtn(false);
                }}
                disabled={disableBtn}
              >
                Deletar
              </Button>
            </ButtonGroup>
          </div>
        );
      },
    },
  ];

  return (
    <Paper sx={{ height: 400, width: "100%" }}>
      <DataGrid
        rows={catalogList.lista ?? []}
        columns={columns}
        getRowId={(row) => row.id} // ou qualquer outra chave única
        initialState={{ pagination: { paginationModel } }}
        sx={{ border: 0 }}
        
        rowCount={catalogList.total}
        page={catalogList.page}
        pageSize={catalogList.limit}

        rowsPerPageOptions={[3, 5, 10, 50, 100]}
        onPageSizeChange={(e) => {
          console.log('onPageSizeChange',e);
          loadCatalog(null, e);
        }}
        paginationMode={"server"}
        onPageChange={(e) => {
          console.log('onPageChange',e);
          loadCatalog(e);
        }}
        loading={loadingCatalogList}
        disableMultipleSelection
        componentsProps={{
          pagination: {
            labelRowsPerPage: "Registros por página",
          },
        }}
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Nenhum catálogo encontrado.
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              Nenhum resultado encontrado.
            </Stack>
          ),
        }}
      />
    </Paper>
  );
}
